import { ProfileManager } from '@/core/administration/ProfileManager'

function switchLanguage (lang) {
	var langParam = 'lang=' + lang
	var url = window.location.href

	if (url[url.length - 1] == '#') {
		url = url.substring(0, url.length - 1)
	}

	if (url.indexOf('?') != -1) {
		//has params
		var langIndex = url.indexOf('lang=')
		if (langIndex != -1) {
			//has lang param (it is always the last)
			url = url.replace(url.substring(langIndex, url.length), langParam)
		} else {
			url = url + '&' + langParam
		}
	} else {
		//no params
		url = url + '?' + langParam
	}

	window.location.href = url
}

function initHeader () {
	// initHeaderDropdownsActions();

	var lang = {
		'ee': 'Estonian',
		'en': 'English',
		'lt': 'Lithuanian',
		'lv': 'Latvian',
		'ru': 'Русский',
	}

	$('img.header_lang-preview, img.header_lang_left-menu').attr('src', window.url_header_lang_image + 'header_lang-' + window.locale + '.png').before(lang[window.locale])


}

export function initHeaderMenu () {
	let $current = location.pathname

	$('.main-menu a, .small-main-menu a').each(function () {
		let $target = $(this).attr('href')
		if ($current === $target) {
			$(this).parent().addClass('uk-active')
		}
	})

	$('.left-menu li').each(function (index, el) {
		let $target = $(el).find('a').attr('href')
		if ($current === $target) {
			$(el).addClass('uk-active')
			$(el).parent().parent().addClass('uk-open')
		}
	})
}

export function initHeaderSelectCompanyForm () {
	var collapse_icon = '<span uk-icon="icon: chevron-down; ratio: .8"></span> '
	$('#current-company, #current-company_left-menu').html(collapse_icon + $('.company_list li.uk-active').eq(0).text())
}
